import * as React from "react";
import {observable, reaction, configure} from "mobx";
import {createRoot} from "react-dom/client";
import {BrowserRouter} from "react-router-dom"
import { Root } from "src/root";

import "src/styles/style.css";
import "src/styles/main.css";
import "src/styles/colors.css";
import { SiteModel } from "src/model/model";

const session = observable(new SiteModel());

createRoot(document.getElementById('root')!).render(
	<BrowserRouter future={{
		v7_startTransition: true,
		v7_relativeSplatPath: true
	}}>
		<Root
		session={session}
		/>
	</BrowserRouter>
);